import React, { FC } from 'react'
import { Dialog, LoadingButton } from '../atoms'
import Button from '@mui/material/Button'
import { RPUser } from '@hazadapt-git/public-core-base'
import { FormikProps } from 'formik'

interface UnsavedProfileChangesModalProps {
    open: boolean
    onClose(): void
    discardChanges(): void
    formikRef: React.RefObject<FormikProps<Partial<RPUser>>>
}

export const UnsavedProfileChangesModal: FC<UnsavedProfileChangesModalProps> = (
    props: UnsavedProfileChangesModalProps
) => {
    return (
        <Dialog
            open={props.open}
            onClose={props.onClose}
            title="Looks like you've got some unsaved changes"
            content={
                "Please select whether you'd like to save your changes or discard them before navigating away from this page."
            }
            ctas={[
                <Button
                    key={'discard-changes'}
                    onClick={() => {
                        props.discardChanges()
                        props.onClose()
                    }}
                    variant="outlined"
                    color="secondary"
                >
                    Discard Changes
                </Button>,
                <LoadingButton
                    key="save-changes"
                    variant="contained"
                    color="primary"
                    onClickAsync={async () => {
                        await props.formikRef.current?.submitForm?.()
                        props.onClose()
                    }}
                >
                    Save Changes
                </LoadingButton>,
            ]}
        />
    )
}
